import Translator from '../../../Shared/translator';
import v0_v1 from './v0_v1';
import v1_v2 from './v1_v2';
import v2_v3 from './v2_v3';
import v3_v4 from './v3_v4';

const translator: Translator = {
  ['v0_v1']: v0_v1,
  ['v1_v2']: v1_v2,
  ['v2_v3']: v2_v3,
  ['v3_v4']: v3_v4
};

export default translator;
